<template>
  <div class="flex flex-col h-full">
    <ThreadsNav show-back :show-center="false">
      <template #right>
        <div>
          <button
            class="btn btn-sm btn-primary"
            @click="router.push({ name: 'mailEdit' })"
          >
            <i class="iconify mingcute--edit-4-line w-4"></i>
            {{ $t(`interactive.sendMail`) }}
          </button>
        </div>
      </template>
    </ThreadsNav>
    <div class="flex-1 flex flex-col overflow-hidden h-full mail-list gap-1">
      <!-- Tabs -->

      <!-- -->
      <div class="overflow-hidden h-full">
        <VanTabs
          :active="activeTab"
          swipeable
          @update:active="onTabChange"
          class="mb-2 overflow-hidden h-full flex flex-col gap-1"
        >
          <VanTab
            v-for="type in list"
            :key="type"
            :title="$t(`mail.${type}`)"
            :name="type"
          >
            <div class="flex gap-1 mb-1 px-4">
              <div class="flex items-center flex-1">
                我的OC：
                <SelectAllMate
                  :active-mate-id="activeMateId"
                  v-model:show="showOcSelector"
                  @confirm="onConfirmOc"
                />
              </div>

              <div
                class="flex items-center flex-1"
                v-if="type === MateMailType.Threadbox && activeMateId"
              >
                Ta的OC：
                <SelectFriendMate
                  class="flex-1 w-full"
                  :active-mate-id="activeMateId"
                  :other-mate-id="otherMateId"
                  :other-mate-name="otherMateName"
                  v-model:show="showOcSelector"
                  @update:other-mate-id="onConfirmOtherOc"
                />
              </div>
            </div>

            <div
              class="flex justify-between my-1 px-2"
              v-if="type === MateMailType.Inbox"
            >
              <div class="flex gap-0">
                <div
                  :class="[
                    'btn btn-xs rounded-r-none',
                    !subTab ? 'btn-primary' : '',
                  ]"
                  @click="clickSubTab(undefined)"
                >
                  全部
                </div>
                <div
                  :class="[
                    'indicator text-xs px-2 flex items-center',
                    subTab === MateMailType.Unread ? 'btn-primary' : 'btn-bg',
                  ]"
                  @click="clickSubTab(MateMailType.Unread)"
                >
                  <span
                    class="indicator-item badge badge-primary rounded-full badge-xs text-primary-content p-0 w-5 h-5 z-[999]"
                    v-if="
                      notificationStore.interactionSummary?.unreadMailCount &&
                      (!activeMateId || activeMateId === mateStore.userMate?.id)
                    "
                  >
                    {{ notificationStore.interactionSummary?.unreadMailCount }}
                  </span>

                  未读
                </div>
                <div
                  :class="[
                    'btn btn-xs rounded-l-none indicator',
                    subTab === MateMailType.Read ? 'btn-primary' : '',
                  ]"
                  @click="clickSubTab(MateMailType.Read)"
                >
                  已读
                </div>
              </div>
              <div class="flex gap-0">
                <div
                  :class="[
                    'btn btn-xs rounded-r-none',
                    subTab === MateMailType.Unreplied ? 'btn-primary' : '',
                  ]"
                  @click="clickSubTab(MateMailType.Unreplied)"
                >
                  未回复
                </div>
                <div
                  :class="[
                    'btn btn-xs rounded-l-none',
                    subTab === MateMailType.Replied ? 'btn-primary' : '',
                  ]"
                  @click="clickSubTab(MateMailType.Replied)"
                >
                  已回复
                </div>
              </div>
            </div>
            <!-- <div
              v-if="
                type === MateMailType.Threadbox &&
                (!activeMateId || !otherMateId)
              "
            >
              <VanEmpty description="请先选择我的OC和Ta的OC" />
            </div> -->

            <ThreadList
              class="flex-1"
              :ref="(el) => (threadListMap[type] = el as unknown as ThreadListInstance)"
              :on-pull-load="() => reload()"
              :on-scroll-load="() => loadNextPage()"
              @on-scroll="onScroll"
            >
              <div class="flex flex-col gap-2 px-4">
                <MateMailItem
                  v-for="mail in listMap[type]"
                  :key="mail.id"
                  :mail="mail"
                  @click="viewMail(mail)"
                  @reload="initListAndReload"
                  :tab-type="type"
                />
              </div>
            </ThreadList>
          </VanTab>
        </VanTabs>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onActivated, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useInteractive } from "@/stores/interactive";
import { MateMail } from "@/types/entity";
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { MateMailType } from "@/enums/mateEnums";
import { useNotification } from "@/stores/notification";
import { useMate } from "@/stores/mate";
import { useDebounceFn } from "@vueuse/core";

const router = useRouter();
const route = useRoute();
const interactiveStore = useInteractive();
const notificationStore = useNotification();
const mateStore = useMate();

type MailType =
  | MateMailType.Inbox
  | MateMailType.Sent
  | MateMailType.Draft
  | MateMailType.Trashed
  | MateMailType.Threadbox;

const activeTab = ref<MailType>(MateMailType.Inbox);
const subTab = ref<MateMailType>();

const listMap = ref<Record<MailType, MateMail[]>>({
  [MateMailType.Inbox]: [],
  [MateMailType.Threadbox]: [],
  [MateMailType.Sent]: [],
  [MateMailType.Draft]: [],
  [MateMailType.Trashed]: [],
});

const heightMap: Record<MailType, number> = {
  [MateMailType.Inbox]: 0,
  [MateMailType.Threadbox]: 0,
  [MateMailType.Sent]: 0,
  [MateMailType.Draft]: 0,
  [MateMailType.Trashed]: 0,
};

const onScroll = (scrollTop: number) => {
  heightMap[activeTab.value] = scrollTop;
};

const viewMail = (mail: MateMail) => {
  if (activeTab.value === MateMailType.Draft) {
    router.push({
      name: "mailEdit",
      query: {
        uuid: mail.uuid,
      },
    });
  } else {
    router.push({
      name: "mailDetail",
      params: {
        uuid: mail.uuid,
      },
      query: {
        type: activeTab.value,
      },
    });
  }
};

const threadListMap = ref<Record<MailType, ThreadListInstance>>(
  {} as Record<MailType, ThreadListInstance>
);

const list: MailType[] = [
  MateMailType.Inbox,
  MateMailType.Threadbox,
  MateMailType.Sent,
  MateMailType.Draft,
  MateMailType.Trashed,
];

const reload = async () => {
  const idx = list.indexOf(activeTab.value);
  if (idx === -1) {
    console.log("idx === -1", activeTab.value);
  }

  listMap.value[activeTab.value] = [];
  threadListMap.value?.[activeTab.value]?.resetScrollLoadingState();
};

const loadNextPage = async () => {
  let mateId = activeMateId.value;
  let _otherMateId = otherMateId.value;

  let currentTab = activeTab.value;
  const list = listMap.value[currentTab];
  const { length } = list;
  const page = length / 5 + 1;
  if (length !== 0 && length % 5 !== 0) return false;

  const type =
    currentTab === MateMailType.Inbox && subTab.value
      ? subTab.value
      : currentTab;

  const res = await interactiveStore.getMailList({
    page,
    type,
    mateId,
    otherMateId: _otherMateId,
  });

  if (mateId !== activeMateId.value || _otherMateId !== otherMateId.value) {
    return false;
  }

  if (page === 1 && [MateMailType.Unread, MateMailType.Inbox].includes(type))
    notificationStore.initSummaryCount();

  listMap.value[currentTab].push(...res);

  return res.length === 5;
};

const clickSubTab = (type?: MateMailType) => {
  subTab.value = type;
  reload();
};

const onTabChange = (active: MailType) => {
  activeTab.value = active;
  if (listMap.value[active].length === 0) {
    reload();
  }
};

const activeMateId = ref<number | undefined>(undefined);
const otherMateId = ref<number | undefined>(undefined);
const showOcSelector = ref(false);

watch(
  () => [activeMateId.value, otherMateId.value, route.query.sourceId],
  () => {
    if (route.name !== "mailList") return;

    initPage();
  }
);
const onConfirmOc = (value?: number) => {
  activeMateId.value = value;
  otherMateId.value = undefined;

  initListAndReload();
  showOcSelector.value = false;
};

const onConfirmOtherOc = (value?: number) => {
  otherMateId.value = value ?? undefined;
  initListAndReload();
  showOcSelector.value = false;
};

const otherMateName = ref<string | undefined>(undefined);

const initRouteQuery = (obj = route.query) => {
  const { type, sourceId, targetId, targetName } = obj;
  if (type) {
    activeTab.value = type as MailType;
  }
  if (sourceId) {
    activeMateId.value = Number(sourceId);
  }
  if (targetName) {
    otherMateName.value = targetName as string;
  }
  if (targetId && !interactiveStore.homeNeedReload) {
    otherMateId.value = Number(targetId);
    router.replace({
      name: "mailList",
    });
    reload();
  }
};

const debounceInitPage = useDebounceFn(() => {
  initRouteQuery();
  if (interactiveStore.homeNeedReload) {
    initListAndReload();
    interactiveStore.homeNeedReload = false;
  }
  if (listMap.value[activeTab.value].length === 0) {
    reload();
  }
}, 200);

const initPage = () => {
  debounceInitPage();
};

const initListAndReload = () => {
  // Reset the listMap to its initial state
  listMap.value = {
    [MateMailType.Inbox]: [],
    [MateMailType.Sent]: [],
    [MateMailType.Draft]: [],
    [MateMailType.Trashed]: [],
    [MateMailType.Threadbox]: [],
  };

  // Reload the current active tab data
  reload();
};

onActivated(() => {
  initPage();
  if (interactiveStore.homeNeedReload) {
    initListAndReload();
    interactiveStore.homeNeedReload = false;
  }
});
</script>

<style>
.mail-list {
  .van-tabs__content {
    flex: 1;
  }
}

.btn-bg {
  background-color: hsl(var(--b2) / var(--tw-bg-opacity));
}
</style>
